'use client';
import { useState } from 'react';
import {
  Spin,
  Form,
  Checkbox,
  Input,
  Select,
  Button,
  message,
  Table,
} from 'antd';
import ProductViewer from './product-viewer';
import SelectionResults from './selection-results';

const { Item: FormItem } = Form;

export default function ProductFilter({ productImages, formData }: any) {
  const [paramsForm] = Form.useForm();
  const [spinning, setSpinning] = useState(false);
  const [resultList, setResultList] = useState([]);

  const column = [
    {
      title: '参数名称',
      dataIndex: 'label',
      key: 'label',
      width: 230,
      align: 'center',
      className: '!bg-[#f0f0f0] text-[#333] font-bold',
      render: (text: string, record: any) => {
        return (
          <div>
            {record.required && <span className="text-main">*</span>}
            <span className="text-[#333]">{text}</span>
          </div>
        );
      },
    },
    {
      title: '参数值名称',
      dataIndex: 'name',
      key: 'name',
      width: 230,
      className: '!bg-white',
      render: (text: string, record: any, index: number) => {
        let component: any = '';

        switch (record.type) {
          case 'Input':
            component = <Input placeholder="请输入值" />;
            break;
          case 'Select':
            component = (
              <Select options={record.options} placeholder="请选择值" />
            );
            break;
          default:
            component = <Input placeholder="请输入值" />;
            break;
        }
        return (
          <FormItem
            rules={[{ required: record.required }]}
            help={''}
            name={text}
          >
            {component}
          </FormItem>
        );
      },
    },
    {
      title: '参数描述',
      dataIndex: 'desc',
      key: 'desc',
      className: '!bg-[#f0f0f0] !text-[#666] text-base',
    },
  ];

  // 获取产品选型数据
  const getProductSelection = () => {
    paramsForm
      .validateFields()
      .then((res) => {
        let formValues = paramsForm.getFieldsValue();

        setSpinning(true);
        // 模拟数据请求
        setTimeout(() => {
          let testResultList: any = [
            {
              key: '1',
              model: 'DGHH15CA-4R-328-ZBC-2-EL14-ER14',
              category: '经济型联轴器',
              type: '梅花式联轴器',
              lockingType: '螺钉固定型',
            },
          ];

          setResultList(testResultList);
          setSpinning(false);
          message.open({
            type: 'success',
            content: '生成成功',
          });
        }, 800);
      })
      .catch((err) => {
        console.log(err);
        message.open({
          type: 'error',
          content: '参数填写不完整',
        });
      });
  };

  // 重置表单
  const resetForm = () => {
    paramsForm.resetFields();
    setResultList([]);
  };

  return (
    <div className="product-filter-component">
      <div className="px-[40px] pt-[16px] pb-[50px] bg-white min-h-[600px] flex gap-x-8">
        {/* 产品查看器 */}
        <ProductViewer productImages={productImages} />
        {/* 产品参数筛选 */}
        <div className="w-[960px]">
          <div
            className={`px-[20px] flex flex-row justify-between items-center bg-[url('/calculation-selection/form_top_bg.png')] bg-cover h-[70px]`}
          >
            <div className="text-white text-xl ml-[16px] font-bold">
              产品参数筛选
            </div>
            <div>
              <button
                className="w-[104px] h-[30px] text-base text-white border-[#fff] border"
                onClick={() => resetForm()}
              >
                重置参数值
              </button>
            </div>
          </div>
          <Form form={paramsForm}>
            {/* @ts-ignore */}
            <Table
              className="params-table"
              showHeader={false}
              dataSource={formData}
              // @ts-ignore
              columns={column}
              pagination={{ defaultPageSize: 100, hideOnSinglePage: true }}
              bordered
            ></Table>
          </Form>
          <div className="mt-[20px] flex items-center justify-end">
            <button
              className="w-[200px] h-[48px] text-[18px] text-white bg-main border-[#fff] border"
              onClick={() => getProductSelection()}
            >
              立即产品选型
            </button>
          </div>
        </div>
      </div>
      {/* 选型结果 */}
      {resultList.length > 0 && <SelectionResults resultList={resultList} />}
      {/* 全屏loading */}
      <Spin spinning={spinning} fullscreen />
      <style>
        {/* antd 默认样式修改 */}
        {`
                    .product-filter-component  .ant-form-item {
                        margin-bottom:0px !important;
                    }

                    .product-filter-component .ant-table-wrapper table
                    .product-filter-component .ant-table-wrapper .ant-table,
                    .product-filter-component .ant-table-wrapper .ant-table-container,
                    .product-filter-component .ant-table-wrapper .ant-table-container table thead tr:first-child *:first-child,
                    .product-filter-component .ant-table-wrapper .ant-table-container table thead tr:first-child *:last-child {
                        border-radius: 0 !important;
                    }
                    .product-filter-component .ant-table-wrapper .ant-table.ant-table-bordered .ant-table-container{
                        border-inline-start: 1px solid #ccc;
                        border-top: 1px solid #ccc;
                    }
                    .product-filter-component .ant-table-wrapper .ant-table-thead tr th, 
                    .product-filter-component .ant-table-wrapper .ant-table-thead tr td {
                        border-inline-end:1px solid #ccc !important;
                        border-bottom: 1px solid #ccc;
                        background: #f0f0f0;
                    }
                    .product-filter-component .ant-table-wrapper .ant-table-tbody tr th, 
                    .product-filter-component .ant-table-wrapper .ant-table-tbody tr td {
                        border-inline-end:1px solid #ccc !important;
                        border-bottom: 1px solid #ccc;
                    }
                `}
      </style>
    </div>
  );
}
